import * as React from 'react';
import Loadable from 'react-loadable';
import { Route, Switch } from 'react-router-dom';
import PageLayout from '../layouts/PageLayout';
import { matchPath } from 'react-router';
import { get } from 'lodash';
import { pages } from '../constants/routes';

const OrderDetailsContainer = Loadable({
  loader: () => import('../containers/order'),
  loading: () => null,
});

export default function (store: any, props: any) {
  const match = props.match;
  const path: any = matchPath(match.url, {
    exact: true,
    path: pages.legacyOrder(':orderId'),
    strict: false,
  });

  const renderComponent = (props: any) => {
    const componentProps = {
      ...props,
      orderId: parseInt(get(path, 'params.orderId', 0)),
    };

    return (
      <>
        <OrderDetailsContainer { ...store } { ...componentProps } />
      </>
    );
  };

  return(
    <Switch>
      <PageLayout>
        <Route
          path={ match.url }
          render={ renderComponent }
        />
      </PageLayout>
    </Switch>
  );
}

